// 订单数据
export function getOrderBaseReport(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/report/getOrderBaseReport',
    data
  })
}

export function getBasePageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/report/getBasePageList',
    data
  })
}
// 地域数据
export function getAreaReport(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/report/getAreaReport',
    data
  })
}
export function getRegionPageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/report/getRegionPageList',
    data
  })
}

// 受众数据
export function getCrowdReport(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/report/getCrowdReport',
    data
  })
}

// 到达数据
export function getReachReport(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/report/getReachReport',
    data
  })
}

// export function getReachPageList (data) {
//   return this.fetch({
//     method: 'post',
//     url: 'api/dsp/report/getReachPageList',
//     data
//   })
// }
// 频次到达
export function getFrequencyPageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/report/getFrequencyPageList',
    data
  })
}
// 频次到达
export function getFrequencyList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/frequency/pageList',
    data
  })
}
// 广告效果
export function getEffectReport(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/report/getEffectReport',
    data
  })
}
